


import { Component, Input } from '@angular/core';
import { AddVisaComponent } from '../add-visa/add-visa.component';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationModalComponent } from '../../dialog-modal/confirmation-modal/confirmation-modal.component';
import { RecruiterService } from 'src/app/services/recruiter/recruiter.service';
import { CommonService } from 'src/app/services/common/common.service';
import { VisaDetail } from 'src/app/model/employees';
import { GlobalService } from 'src/app/services/global/global.service';

@Component({
  selector: 'app-visa',
  templateUrl: './visa.component.html',
  styleUrls: ['./visa.component.scss']
})
export class VisaComponent {
  items = [
    // { image: 'assets/images/pages/bg-01.png', id: 0 },
    // { image: 'assets/images/pages/bg-02.png', id: 1 },
    // { image: 'assets/images/pages/bg-03.png', id: 2 },
    // { image: 'assets/images/pages/bg-04.png', id: 3 },
    // { image: 'assets/images/pages/bg-01.png', id: 4 },
  ];
  pItems = [
    // { pass_img: 'assets/images/pages/bg-01.png', id: 0 },
    // { pass_img: 'assets/images/pages/bg-02.png', id: 1 },
    // { pass_img: 'assets/images/pages/bg-03.png', id: 2 },
    // { pass_img: 'assets/images/pages/bg-04.png', id: 3 },
    // { pass_img: 'assets/images/pages/bg-01.png', id: 4 },
  ];
  visibleItems: any[] = [];
  visibleItemsPass: any[] = [];
  currentIndex = 0;
  itemsPerPage = 3;
  currentIndexPass = 0;
  itemsPerPagePass = 3;
  @Input() employeeId!: string | number;
  public visaDetail !: VisaDetail;
  public isVisaRecord: Boolean = false;
  constructor(public dialog: MatDialog, public recruiterService: RecruiterService, private commonService: CommonService) { }

  ngOnInit(): void {
    this.getVisaDetail()
  }
  getVisaDetail() {
    let obj = {
      em_i: this.employeeId,
    }
    this.recruiterService.visaDetail(obj).subscribe({
      next: (success: any) => {
        //this.spinner.hide()
        this.visaDetail = success.msg;

        if (success.msg.visa.length != 0) {
          this.items = [];
          this.items = success.msg.visa
        }
        if (success.msg.pass_img.length != 0) {
          this.pItems = []
          this.pItems = success.msg.pass_img
        }
        this.updateVisibleItems();
        this.updatePassVisibleItems()
        if (this.visaDetail.passport_number && this.visaDetail.ex_dt) {
          this.isVisaRecord = true;
        }



      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });
  }
  updateVisibleItems() {
    if (this.currentIndex + this.itemsPerPage > this.items.length) {
      this.visibleItems = [
        ...this.items.slice(this.currentIndex, this.items.length),
        ...this.items.slice(0, (this.currentIndex + this.itemsPerPage) % this.items.length)
      ];
    } else {
      this.visibleItems = this.items.slice(this.currentIndex, this.currentIndex + this.itemsPerPage);
    }
  }
  prev() {
    this.currentIndex = (this.currentIndex - this.itemsPerPage + this.items.length) % this.items.length;
    this.updateVisibleItems();
  }

  next() {
    this.currentIndex = (this.currentIndex + this.itemsPerPage) % this.items.length;
    this.updateVisibleItems();
  }

  updatePassVisibleItems() {
    if (this.currentIndexPass + this.itemsPerPagePass > this.pItems.length) {
      this.visibleItemsPass = [
        ...this.pItems.slice(this.currentIndexPass, this.pItems.length),
        ...this.pItems.slice(0, (this.currentIndexPass + this.itemsPerPagePass) % this.pItems.length)
      ];
    } else {
      this.visibleItemsPass = this.pItems.slice(this.currentIndexPass, this.currentIndexPass + this.itemsPerPagePass);
    }
  }
  prevPass() {
    this.currentIndexPass = (this.currentIndexPass - this.itemsPerPagePass + this.pItems.length) % this.pItems.length;
    this.updatePassVisibleItems();
  }

  nextPass() {
    this.currentIndexPass = (this.currentIndexPass + this.itemsPerPagePass) % this.pItems.length;
    this.updatePassVisibleItems();
  }

  onEdit() {

    console.log(this.employeeId)

    let dataObj = {
      width: '90%', height: '98%', maxHeight: '780px', maxWidth: '643px',
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms"
    }
    // if (this.isVisaRecord) { // this is removed by ankush
      dataObj["data"] = this.visaDetail;
      dataObj["em_i"] = this.employeeId;
    // }
    const dialogRef = this.dialog.open(AddVisaComponent, dataObj);

    dialogRef.afterClosed().subscribe(result => {
      // if (result && (result["content_added"] == true)) {
        this.getVisaDetail()
      // }
    });
  }

  acceptReject(type, value) {
    let dataObj = {
      v_acp: value,
      em_i: this.employeeId
    }
    const dialogRef = this.dialog.open(ConfirmationModalComponent, {
      data: { content_type: 'accept_reject', data_type: type, dataObj: dataObj, item_type: "visa_accept" }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result["confirm_yes"] == 'yes') {
        this.getVisaDetail()
      }
    });
  }
  
  checkUrl(url: any) {
    let newUrl;
    if (url?.includes("https")) {
      newUrl = url;
    } else {
      newUrl = GlobalService.imageURL + url;
    }
    return newUrl;
  }
}
